import { getDataGridToolbarProps } from 'features/shared/utility/dataGridToolbarHelper';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { CommonDataGrid } from 'features/shared/components/table';
import { RMSButton } from 'features/shared/components/buttons';
import usePermissions from 'features/shared/hooks/usePermissions';
import { PERMISSION_RESOURCES } from 'features/shared/constants/permissionResources';
import { executeApiAction } from 'features/shared/utility/apiHelper';
import { notifyDataUpdate } from 'reducers/DataUpdateReducer';
import { getVehicleRegistrations, getVehicleDetails } from '../../services/vehicleService';
import { VEHICLE_REGISTRATION_COLUMNS } from '../../constants/vehicleRegistrationsTabConstants';
import VehicleRecordRegistrationDialog from './VehicleRecordRegistrationDialog';

const VehicleRegistrationsTab = ({ ptsVehicleID, canEdit: canEditVehicle = true }) => {
  const dispatch = useDispatch();
  const vehiclePermissions = usePermissions(PERMISSION_RESOURCES.VEHICLE);
  const canEdit = canEditVehicle && vehiclePermissions.Edit;
  const [rows, setRows] = useState([]);
  const [vehicle, setVehicle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const load = useCallback(
    () =>
      executeApiAction({
        dispatch,
        setLoading,
        action: () =>
          Promise.all([getVehicleRegistrations(ptsVehicleID), getVehicleDetails(ptsVehicleID)]),
        onSuccess: ([registrations, details]) => {
          setVehicle(details);
          setRows(
            registrations.map((row) => ({
              ...row,
              VehicleID: details?.VehicleID,
            }))
          );
        },
      }),
    [dispatch, ptsVehicleID]
  );
  useEffect(() => {
    load();
  }, [load]);
  const saved = () => {
    setFormOpen(false);
    dispatch(notifyDataUpdate({ type: 'vehicle-reg', data: { ptsVehicleID } }));
    load();
  };
  return (
    <Box className="vehicle-grid-tab">
      <Box className="person-addresses-tab__toolbar">
        <RMSButton
          label="Add Registration"
          prefixIcon={<AddIcon />}
          disabled={!canEdit || loading || !vehicle}
          onClick={() => {
            setEditing(null);
            setFormOpen(true);
          }}
        />
      </Box>
      <CommonDataGrid
        rows={rows}
        columns={VEHICLE_REGISTRATION_COLUMNS}
        loading={loading}
        getRowId={(row) => row.ptsRegistrationID}
        toolbar={getDataGridToolbarProps({ printTitle: 'Vehicle Registrations' })}
        actions={{
          edit: {
            visible: true,
            disabled: !canEdit || loading,
            onClick: (row) => {
              setEditing(row);
              setFormOpen(true);
            },
          },
        }}
      />
      {formOpen && (
        <VehicleRecordRegistrationDialog
          open
          canSave={canEdit}
          registration={{ ...vehicle, Color: vehicle?.PrimaryColor, ...editing, ptsVehicleID }}
          onClose={() => setFormOpen(false)}
          onSaved={saved}
        />
      )}
    </Box>
  );
};
export default VehicleRegistrationsTab;
